module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.e2d60bc4.ttf";